import React, { useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import Pattern from "../../components/ui/Pattern";
import { isMobileOrTabletDevice } from "../../utils/deviceDetection";
import { all_routes } from "../router/all_routes";

interface AuthCardLayoutProps {
  icon: string;
  title: string;
  subtitle: React.ReactNode;
  children?: React.ReactNode;
  tone?: "primary" | "success";
  showBackToLogin?: boolean;
}

const AuthCardLayout: React.FC<AuthCardLayoutProps> = ({
  icon,
  title,
  subtitle,
  children,
  tone = "primary",
  showBackToLogin = true,
}) => {
  const [showPattern] = useState(() => !isMobileOrTabletDevice());

  return (
    <div className="account-content">
      <div className="login-wrapper w-100 min-vh-100 position-relative overflow-hidden">
        {showPattern && (
          <div
            className="position-absolute w-100 h-100 top-0 start-0 pointer-events-none"
            style={{ zIndex: 0 }}
          >
            <Pattern />
          </div>
        )}
        <div
          className="login-content w-100 position-relative"
          style={{ zIndex: 1 }}
        >
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-4">
                <div className="login-user-info">
                  <div className="text-center mb-4">
                    <ImageWithBasePath
                      src="assets/img/Logo.png"
                      className="img-fluid login-logo"
                      alt="Logo"
                    />
                  </div>

                  <div className="text-center mb-4">
                    <span className={`avatar avatar-xl rounded-circle bg-${tone}-transparent mb-3`}>
                      <i className={`ti ${icon} fs-24 text-${tone}`} />
                    </span>
                    <h4 className="mb-2">{title}</h4>
                    <p className="text-muted mb-0">{subtitle}</p>
                  </div>

                  {children}

                  {showBackToLogin && (
                    <div className="text-center mt-4">
                      <Link
                        to={all_routes.login}
                        className="text-primary fw-medium d-inline-flex align-items-center"
                      >
                        <i className="ti ti-arrow-left me-1" />
                        Back to Login
                      </Link>
                    </div>
                  )}
                </div>
                <p className="text-muted text-center mt-3 mb-0">
                  Copyright © {new Date().getFullYear()} - Cloudee
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthCardLayout;
